export default {"src":"/_next/static/media/logo.f8b8eeb1.svg","height":66,"width":230,"blurWidth":0,"blurHeight":0};